import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

const api = axios.create({
  baseURL: `${API_BASE}/api`,
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' },
});

// Auth token interceptor
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('venue_app_token');
  if (token && token.trim() !== '') {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // Region header — skip for global requests (multi-country)
  const regionParam = config.params?.region;
  if (regionParam && regionParam !== 'global') {
    config.headers['x-region'] = regionParam;
  } else if (!regionParam) {
    config.headers['x-region'] = 'th';
  }

  // Locale header for i18n
  const locale = localStorage.getItem('hl_locale') || 'en';
  config.headers['x-locale'] = locale;

  return config;
});

// Response error handler
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('venue_app_token');
      // Dispatch a custom event so auth stores can react
      window.dispatchEvent(new CustomEvent('auth:unauthorized'));
    }
    return Promise.reject(error);
  }
);

export default api;
